<template>
  <div class="bg-white px-3 index">
    <div class="add_tits" ref="title">
      <el-form class="form-inlines u-f u-jsb" :inline="true">
        <div>
          <el-form-item label="模糊搜索">
            <el-input v-model="title" placeholder="请输入内容" size="small"></el-input>
          </el-form-item>
          <el-form-item label="职称:">
            <el-cascader :options="doctitle_options" v-model="jobname" clearable size="small"
              :props="{ value: 'id', label: 'name', children: 'children' }"></el-cascader>
          </el-form-item>
          <el-form-item label="科室:">
            <el-cascader :options="depat_options" v-model="ksname" clearable size="small"
              :props="{ value: 'id', label: 'name', children: 'children' }"></el-cascader>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="status_value" placeholder="请选择" clearable size="small">
              <el-option v-for="item in status_options" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="ibox-content">
      <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
        <el-table-column prop="id" label="ID" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="user_id" label="医生ID" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="nickname" label="昵称" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="real_name" label="真实姓名" width="80"></el-table-column>
        <el-table-column prop="phone" label="手机号码" width="120"></el-table-column>
        <el-table-column prop="identity_card" label="身份证号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="email" label="电子邮箱" show-overflow-tooltip></el-table-column>
        <el-table-column prop="hospital.hospital_name" label="医院" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.hospital_id">
              {{ scope.row.hospital.hospital_name }}
            </div>
            <div v-else class="reds">{{ scope.row.new_hospital }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="competent_id_text" label="职称" show-overflow-tooltip width="100"></el-table-column>
        <el-table-column prop="inviter_nickname" label="邀请人" width="100"></el-table-column>
        <el-table-column prop="department_id_text" label="科室" show-overflow-tooltip width="100"></el-table-column>
        <el-table-column prop="examine_text" label="审核状态" width="100">
          <template slot-scope="scope">
            <div :class="scope.row.examine == 1 ? 'greens' : 'reds'">
              {{ scope.row.examine_text }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="审核" width="150" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleExamine(scope.$index, scope.row)">审核
            </el-button>
            <el-button size="mini" type="danger" @click="handleDel(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="u-f u-ac u-jsb ft_mr">
        <div></div>
        <div>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper" :total="count">
          </el-pagination>
        </div>
      </div>
    </div>
    <!--  -->
    <el-dialog title="入驻审核" :visible.sync="dialogs" top="80px" center class="dialogs">
      <el-divider></el-divider>
      <div class="dialog-ibox-content">
        <el-form ref="form" :model="form" label-width="140px" :rules="rule" class="demo-ruleForm">
          <el-form-item label="邀请人:">{{jbxxItem.inviter_nickname}}</el-form-item>
          <el-form-item label="审核:">
            <el-radio-group v-model="form.examine">
              <el-radio :label="1">通过</el-radio>
              <el-radio :label="2">未通过</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="form.examine == '2'">
            <el-form-item label="拒绝理由" prop="result">
              <el-input size="small" v-model="form.result" type="textarea" :rows="4"></el-input>
            </el-form-item>
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="身份证:">
                <div v-if="jbxxItem && jbxxItem.identity_card_pic" class="u-f u-wrap">
                  <div v-for="(item, index) in jbxxItem.identity_card_pic" :key="index" class="img_pd"
                    @click="goprev(item)">
                    <img :src="item.url" alt="" width="100" height="100" />
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="医师执业证书:">
                <div v-if="jbxxItem && jbxxItem.physician_card_pic.length > 0" class="u-f u-wrap">
                  <div v-for="(item, index) in jbxxItem.physician_card_pic" :key="index" class="img_pd"
                    @click="goprev(item)">
                    <img :src="item.url" alt="" width="100" height="100" />
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="医师资格证书:" v-if="source == 1">
                <div v-if="jbxxItem && jbxxItem.physician_seniority_pic.length > 0" class="u-f u-wrap">
                  <div v-for="(item, index) in jbxxItem.physician_seniority_pic" :key="index" class="img_pd"
                    @click="goprev(item)">
                    <img :src="item.url" alt="" width="100" height="100" />
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="专业技术资格证:" v-if="source == 1">
                <div v-if="jbxxItem && jbxxItem.competent_certificate_pic" class="u-f u-wrap">
                  <div v-for="(item, index) in jbxxItem.competent_certificate_pic" :key="index" class="img_pd"
                    @click="goprev(item)">
                    <img :src="item.url" alt="" width="100" height="100" />
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-divider></el-divider>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit('form')" size="small">确 定</el-button>
        <el-button @click="dialogs = false" size="small">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialog_prev" width="60vw" top="5vh">
      <div style="margin: -60px -20px -30px -20px">
        <img :src="urls" class="w-100" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  import invitable from "../../../components/settle/table";
  export default {
    components: {
      invitable,
    },
    data() {
      return {
        // 头像
        imageUrl: "",
        status_options: [{
            id: 0,
            name: "待审",
          },
          {
            id: 1,
            name: "通过",
          },
          {
            id: 2,
            name: "未通过",
          },
        ],
        status_value: "",
        dialog: false,
        dialog_info: false,
        title: "",
        loading: false,
        tableData: [],
        currentPage: 1,
        pagesize: 15,
        count: 0,
        heights: null,
        depat_options: [],
        doctitle_options: [],
        hos_options: [],

        //
        eid: "",

        dialogs: false,
        form: {
          examine: "",
          result: "",
        },

        rule: {
          result: [{
            required: true,
            message: "请填写拒绝通过的理由",
            trigger: "blur",
          }, ],
        },
        //
        dialog_prev: false,
        urls: "",
        jbxxItem: "",
        //
        dialog_invite: false,
        invitindex: 0,
        doc_id: "",

        ksname: "",
        jobname: "",
        source: 1,
      };
    },
    computed: {
      ...mapState({
        user: (state) => state.user.user,
      }),
    },
    created() {
      if (this.$route.query.type) {
        this.status_value = this.$route.query.type - 0;
      }
    },
    mounted() {
      let that = this;
      that.getHeight();
      that.begin();
      this.gethos();
      this.getdepart();
      this.getdoctit();
    },
    methods: {
      // 获取高度
      getHeight() {
        let that = this;
        var title = that.$refs.title.offsetHeight;
        that.heights = window.innerHeight - title - 210 + "px";
        window.onresize = () => {
          var title = that.$refs.title.offsetHeight;
          that.heights = window.innerHeight - title - 210 + "px";
        };
      },

      begin() {
        let that = this;
        that.currentPage = 1;
        that.pagesize = 15;
        that.search();
      },
      search() {
        let that = this;
        that.loading = true;
        axios
          .post(
            "/admin/doctorAudit/index", {
              examine: that.status_value,
              keyword: that.title,
              page: that.currentPage,
              page_count: that.pagesize,
              department_id: this.ksname ?
                this.ksname[this.ksname.length - 1] :
                "",
              competent_id: this.jobname ?
                this.jobname[this.jobname.length - 1] :
                "",
            }, {
              token: true,
            }
          )
          .then((response) => {
            that.tableData = response.data.data.list;
            that.count = response.data.data.totalCount;
            that.loading = false;
          })
          .catch((error) => {});
      },
      handleSizeChange(val) {
        let that = this;
        that.pagesize = val;
        that.search();
      },
      handleCurrentChange(val) {
        let that = this;
        that.currentPage = val;
        that.search();
      },
      submit(formName) {
        let that = this;
        that.$refs[formName].validate((valid) => {
          if (valid) {
            axios
              .post(
                "/admin/doctorAudit/ExamineData", {
                  id: that.eid,
                  examine: that.form.examine,
                  examine_result: that.form.result,
                  author: that.user.id,
                  source: this.source,
                }, {
                  token: true,
                }
              )
              .then((response) => {
                if (response.data.code == "200") {
                  if (this.form.examine == 1) {
                    this.getpoint();
                  }
                  that.dialogs = false;
                  that.search();
                  that.$message({
                    message: "操作成功",
                    type: "success",
                  });
                } else {
                  that.$message.error(response.data.msg);
                }
              })
              .catch((error) => {});
          } else {
            that.$alert("信息遗漏未填");
            return false;
          }
        });
      },
      // 积分
      getpoint() {
        axios
          .post(
            "/admin/Kcurrency/KcurrencyRecord", {
              action: 18,
              type: 1,
              data_id: this.jbxxItem.id,
              source: 6,
              modular: 6,
              userId: this.jbxxItem.user_id,
            }, {
              token: true,
            }
          )
          .then((response) => {})
          .catch((error) => {});
      },

      handleExamine(index, row) {
        let that = this;
        that.dialogs = true;
        this.jbxxItem = "";
        that.eid = row.id;
        that.source = row.source;
        that.clear();
        axios
          .post(
            "/admin/doctorAudit/readExamine", {
              id: that.eid,
              source: this.source,
            }, {
              token: true,
            }
          )
          .then((res) => {
            if (res.data.code == 200) {
              var data = res.data.data;
              this.jbxxItem = res.data.data;
              that.form.examine = data.examine;
              that.form.result = data.examine == "1" ? "" : data.examine_result;
            } else {
              that.eid = "";
            }
          })
          .catch((error) => {});
      },

      clear() {
        let that = this;
        that.form.examine = "";
        that.form.result = "";
      },
      goprev(item) {
        let that = this;
        that.dialog_prev = true;
        that.urls = item.url;
      },
      handleDel(index, row) {
        this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            axios
              .post(
                "/admin/doctorAudit/delExamine", {
                  id: row.id,
                }, {
                  token: true,
                }
              )
              .then((response) => {
                if (response.data.code == "200") {
                  this.search();
                  this.$message({
                    type: "success",
                    message: "删除成功!",
                  });
                } else {
                  this.$message({
                    type: "error",
                    message: response.data.msg,
                  });
                }
              })
              .catch((error) => {});
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      },

      // 获取医院
      gethos() {
        let that = this;
        axios
          .post(
            "/admin/HospitalSelect", {}, {
              token: true,
            }
          )
          .then((response) => {
            this.hos_options = response.data.data;
          })
          .catch((error) => {});
      },
      IterDelateChildren(arr) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].children) {
            if (arr[i].children.length) {
              this.IterDelateChildren(arr[i].children);
            } else {
              delete arr[i].children;
            }
          }
        }
        return arr;
      },
      // 获取科室
      getdepart() {
        let that = this;
        axios
          .post(
            "/admin/showSectionList", {
              // pid: 44
            }, {
              token: true,
            }
          )
          .then((response) => {
            this.depat_options = this.IterDelateChildren(response.data.data);
          })
          .catch((error) => {});
      },
      // 获取职称
      getdoctit() {
        let that = this;
        axios
          .post(
            "/admin/showCompetentList", {
              // pid: 10
            }, {
              token: true,
            }
          )
          .then((response) => {
            this.doctitle_options = this.IterDelateChildren(response.data.data);
          })
          .catch((error) => {});
      },

      //
    },
  };
</script>
<style scoped>
  ::v-deep .el-dialog__body {
    padding-top: 0;
    padding-bottom: 0;
  }

  .index {
    border-radius: 6px;
    padding-bottom: 10px;
  }

  .img_pd {
    margin: 2px 5px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .codeImg {
    width: 70%;
    margin: 0 auto;
  }

  .codeImg img {
    width: 100%;
  }
</style>